<template>
  <div class="sub-home" v-if="Object.keys(subHome).length > 0">
    <section class="info">
      <div class="box">
        <h3 class="title">商家信息</h3>
        <div class="info-details clearfix" v-if="subHome.merchantInfo">
          <p class="txt">店铺名称：{{ subHome.merchantInfo.name }}</p>
          <p class="txt">公司名称：{{ subHome.merchantInfo.companyName }}</p>
          <p class="txt">入驻时间：{{ subHome.merchantInfo.addTime }}</p>
          <p class="txt">到期时间：{{ subHome.merchantInfo.expires }}</p>
        </div>
        <div class="state clearfix" v-if="subHome.merchantInfo">
          <div class="status">
            {{ statusCode[subHome.merchantInfo.state - 1] }}
          </div>
          <span class="txt">店铺运营状态</span>
        </div>
      </div>
      <div class="box">
        <h3 class="title">待办事项</h3>
        <div class="to-do__list">
          <div class="item">
            <span class="circle">
              {{ subHome.sendOrder }}
            </span>
            待发货订单
          </div>
          <div class="item">
            <span class="circle">
              {{ subHome.afterSalesOrder }}
            </span>
            售后订单
          </div>
          <div class="item">
            <span class="circle">
              {{ subHome.errorGoods }}
            </span>
            违规下架商品
          </div>
        </div>
      </div>
      <div class="box">
        <h3 class="title">系统公告</h3>
        <div class="notice">
          <el-scrollbar style="height: 100%" :native="false">
            <el-tooltip
              v-for="item in subHome.noticeList"
              class="tiem clearfix"
              effect="light"
              placement="bottom-start"
              :content="item.name"
              :key="item.name"
            >
              <span class="txt">{{ item.name }}</span>
              <span class="time">{{ item.time }}</span>
            </el-tooltip>
          </el-scrollbar>
        </div>
      </div>
    </section>
    <section class="views-data">
      <div class="chart">
        <div class="chang-data">
          <el-button
            size="120"
            round
            class="fff-color"
            v-for="(title, idxs) in orderDataTitle"
            :key="idxs"
            @click="changeChartsData(idxs, 'order')"
            v-text="title"
            :class="idxs === orderTitleIndex ? 'active' : ''"
          />
        </div>
        <div class="tips">
          <span class="category">跨境</span>
          <span class="category">完税</span>
        </div>
        <chart-line
          v-bind="$attrs"
          :chartLineData="chartLineData"
          :legendVisible="false"
          :loading="loading"
          :dataEmpty="chartLineData.rows && chartLineData.rows.length === 0"
          :chartLineSettings="chartLineSettings"
          :colors="['#ff3649', '#34313a']"
          height="32rem"
          :style="{ top: '5rem', padding: '0  2rem' }"
        />
      </div>
      <div class="goods-rank">
        <h3 class="title">三个月热销商品排行</h3>
        <div class="rank">
          <div class="nav">
            <span>排名</span>
            <span>商品名称</span>
            <span>
              销量
            </span>
          </div>
          <el-scrollbar tag="ul" style="height: 100%" :native="false">
            <li class="item" v-for="(item, i) in subHome.goodsList" :key="i">
              <span class="num">TOP {{ i + 1 }}</span>
              <el-tooltip
                effect="light"
                placement="bottom-start"
                :content="item.name"
              >
                <span class="goods-name">{{ item.name }}</span>
              </el-tooltip>
              <span class="volume">
                {{ item.num }}
              </span>
            </li>
          </el-scrollbar>
        </div>
      </div>
    </section>
    <section class="pv-chart">
      <div class="chang-data">
        <el-button
          size="120"
          round
          class="fff-color"
          v-for="(title, idx) in visitDataTitle"
          :key="idx"
          @click="changeChartsData(idx, 'flow')"
          v-text="title"
          :class="idx === visitTitleIndex && 'active'"
        />
      </div>
      <chart-line
        v-bind="$attrs"
        :chartLineData="chartPvData"
        :legendVisible="false"
        :loading="loading"
        :dataEmpty="chartPvData.rows && chartPvData.rows.length === 0"
        :chartLineSettings="chartPvSettings"
        height="32rem"
        :style="{ top: '6rem', padding: '0  2rem' }"
      />
    </section>
    <section class="view-chart">
      <div class="pie">
        <chart-ring
          v-bind="$attrs"
          :chartRingData="chartRingData"
          :legendVisible="false"
          :dataEmpty="chartRingData.rows === 0"
          :chartRingSettings="chartRingSettings"
          height="22rem"
          style="left: -4rem"
          :colors="['#ff3649', '#34313a', '#d4b68a']"
        />
      </div>
      <MapCity
        class="map"
        :btn="subBtn"
        :chartMapData="chartMapData"
        :pagination="pagination"
        :changeData="_getVipAreaData"
      />
    </section>
  </div>
</template>
<script>
import chartLine from 'components/Chart/Line/'
import chartRing from 'components/Chart/Ring/'
import resize from 'mixins/chartsResize/'
import MapCity from 'components/MapCity'

export default {
  name: 'subHome',
  mixins: [resize],
  components: {
    chartLine,
    chartRing,
    MapCity
  },
  data() {
    this.appletsId = this.$route.query.applet_id
    this.statusCode = ['待审核', '审核通过', '审核拒绝', '关闭']
    this.orderDataTitle = ['实时交易数据', '7天交易数据', '30天交易数据']
    this.visitDataTitle = ['实时访问数据', '7天访问数据', '30天访问数据']
    this.subBtn = [
      {
        title: '全部省份',
        mode: 'member',
        type: 'province'
      },
      {
        title: '全部城市',
        mode: 'member',
        type: 'city'
      }
    ]
    this.keyMap = {
      order_data: {
        name: 'chartLineData',
        subName: 'rows',
        date_time: '日期',
        cross_border_amount: '跨境',
        duty_pay_amount: '完税',
        adds: [
          {
            name: 'columns',
            value: ['日期', '跨境', '完税']
          }
        ]
      },
      visit_data: {
        name: 'chartPvData',
        subName: 'rows',
        date_time: '日期',
        visit_number: '访问用户',
        order_quantity: '下单用户',
        adds: [
          {
            name: 'columns',
            value: ['日期', '访问用户', '下单用户']
          }
        ]
      },
      area_data: {
        name: 'chartMapData',
        subName: 'rows',
        area_name: 'area',
        member_number: '会员',
        adds: [
          {
            name: 'columns',
            value: ['area', '会员']
          }
        ]
      },
      statistics_info: {
        name: 'info',
        after_sales_order: 'afterSalesOrder',
        illegal_shelf_goods: 'errorGoods',
        send_order: 'sendOrder',
        merchant_info: {
          name: 'merchantInfo',
          add_time: 'addTime',
          enterprise_name: 'companyName',
          license_date: 'expires',
          merchant_id: 'merchantId',
          merchant_name: 'name',
          merchant_state: 'state'
        },
        notice_list: 'noticeList',
        goods_list: 'goodsList',
        goods_id: 'id',
        goods_name: 'name',
        sales_number: 'num'
      }
    }
    this.chartLineSettings = {}
    this.chartPvSettings = {
      area: true,
      areaStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              // '#c23531','#2f4554', '#61a0a8',
              offset: 0,
              color: 'rgba(90,177,239,1)' // 0% 处的颜色
            },
            {
              offset: 1,
              color: 'rgba(90,177,239,0.1)' // 100% 处的颜色
            }
          ],
          global: false // 缺省为 false
        }
      }
    }
    this.chartRingSettings = {
      radius: [80, 110]
    }
    return {
      loading: false,
      subHome: {},
      chartRingData: {},
      chartLineData: {},
      chartPvData: {},
      chartMapData: {},
      orderTitleIndex: 0,
      visitTitleIndex: 0,
      pagination: {
        currentPage: 1,
        recordTotal: -1,
        pageTotal: -1
      }
    }
  },
  watch: {
    $route: {
      handler(to) {
        this._getData(to.query)
        this._getOrderData({
          search_mode: 'real_time',
          entry_mode: 'order'
        })
        this._getVisitData({
          search_mode: 'real_time',
          entry_mode: 'flow'
        })
        this._getVipAreaData({
          search_mode: 'member',
          curpage: 1,
          see_type: 'province'
        })
      },
      immediate: true
    }
  },
  methods: {
    /**
     * 获取数据
     * @param params
     * @private
     */
    _getData(params) {
      return this.api.getSubHomeData(params).then(res => {
        this.utils._modifyObjKey(res, this.keyMap)
        this.subHome = res.info
        this.chartRingData = this.$store.state.chartRingData.chartRingData[
          this.$route.query.index
        ]
      })
    },
    /**
     * 获取交易订单数据
     * @param params
     * @private
     */
    _getOrderData(params) {
      return this.api.changeData(params).then(res => {
        this._setChartsData(res, this.keyMap, 'chartLineData')
      })
    },
    /**
     * 设置图表数据
     * @param res
     * @param keyMap
     * @param key
     * @private
     */
    _setChartsData(res, keyMap, key) {
      this.utils._modifyObjKey(res, keyMap)
      this[key] = res[key]
    },
    /**
     * 获取PV数据
     * @param params
     * @private
     */
    _getVisitData(params) {
      return this.api.changeData(params).then(res => {
        this._setChartsData(res, this.keyMap, 'chartPvData')
      })
    },
    /**
     * 切换图表数据
     * @param idx
     * @param type
     */
    async changeChartsData(idx, type) {
      const params = ['real_time', 'seven_day', 'thirty_day']
      this.loading = true
      const data = {
        applet_id: this.appletsId,
        search_mode: params[idx]
      }
      if (type === 'order') {
        this.orderTitleIndex = idx
        data.entry_mode = type
        await this._getOrderData(data)
      } else {
        this.visitTitleIndex = idx
        data.entry_mode = type
        await this._getVisitData(data)
      }
      this.loading = false
    },
    /**
     * 获取会员分布数据
     * @param params
     */
    _getVipAreaData(params) {
      this.api.getVipAreaData(params).then(res => {
        this.utils._modifyObjKey(res, this.keyMap)
        this.chartMapData = res.chartMapData
        this.pagination.pageTotal = +res.page_count
      })
    }
  }
}
</script>
<style lang="scss">
.sub-home {
  min-width: calc(1920px - 2.6rem);
  width: calc(100% - 2.6rem);

  .info,
  .views-data {
    display: flex;
    margin-right: -1.3rem;
  }

  .info {
    .box {
      flex: 1;
      height: 18.8rem;
      margin-right: 1.3rem;
      margin-bottom: 1.3rem;
      padding: 1.2rem;
      background-color: #fff;
      overflow: hidden;
    }

    .title {
      padding-bottom: 1.1rem;
      border-bottom: 1px solid colors('bor-main');
    }

    .info-details {
      float: left;
      margin-top: 2.4rem;

      .txt {
        padding-bottom: 0.5rem;
      }
    }

    .state {
      float: right;
      margin: 3.5rem 3.9rem 0 0;
    }

    .status {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 4.5rem;
      height: 4.5rem;
      border: solid 0.2rem #34313a;
      margin-bottom: 1rem;
      font-size: 1rem;
      font-weight: bold;
    }

    .to-do__list {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 15.4rem;
      text-align: center;

      .item {
        flex: 1;

        &:nth-child(1) {
          .circle {
            background-color: #fd3d44;
          }
        }

        &:nth-child(2) {
          .circle {
            background-color: #516ae1;
          }
        }

        &:nth-child(3) {
          .circle {
            background-color: #1fcb94;
          }
        }

        &:nth-child(4) {
          .circle {
            background-color: #ff592f;
          }
        }
      }

      .circle {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 3.8rem;
        height: 3.8rem;
        border-radius: 50%;
        margin: 0 auto 1.5rem;
        color: #fff;
        font-weight: bold;
      }
    }

    .notice {
      padding-top: 1.8rem;
      height: 236px;
      overflow: hidden;

      .item {
        margin-bottom: 1.1rem;
      }

      .txt {
        float: left;
      }

      .time {
        float: right;
      }
    }
  }

  .views-data {
    .chart {
      position: relative;
      width: calc(66.66% - 1.3rem);
      height: 38.8rem;
      margin-right: 1.3rem;
      background-color: #fff;
    }

    .goods-rank {
      width: calc(33.33% - 1.3rem);
      height: 38.8rem;
      margin-right: 1.3rem;
      background-color: #fff;
    }

    .tips {
      position: relative;
      top: 4.5rem;
      right: 2.5rem;
      float: right;
      z-index: 90;
    }

    .category {
      position: relative;

      &:before {
        content: '';
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: -1rem;
        width: 0.4rem;
        height: 0.4rem;
        border-radius: 50%;
      }

      &:nth-child(1) {
        margin-right: 2rem;

        &:before {
          background-color: colors('bg-sub');
        }
      }

      &:nth-child(2) {
        &:before {
          background-color: colors('bg-main');
        }
      }
    }

    .goods-rank {
      padding: 1.2rem;
      overflow: hidden;
    }

    .title {
      padding-bottom: 1.1rem;
      border-bottom: 1px solid colors('bor-main');
    }

    .rank {
      padding-top: 2.3rem;
      height: 34rem;
      overflow: hidden;
    }

    .nav {
      display: flex;
      margin-bottom: 1.6rem;

      span {
        font-size: 0.9rem;
        font-weight: bold;

        &:nth-child(1) {
          flex: 0.8;
        }

        &:nth-child(2) {
          flex: 2.4;
          padding-right: 1rem;
        }

        &:nth-child(3) {
          flex: 0.8;
        }
      }
    }

    .item {
      @extend .nav;
      margin-bottom: 1rem;

      span {
        font-weight: normal;
        @extend .ellipses;
      }
    }
  }

  .chang-data {
    position: absolute;
    top: 4rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 200;
  }

  .pv-chart {
    position: relative;
    width: 100%;
    height: 38.8rem;
    margin: 1.3rem 0;
    background-color: #fff;
  }

  .view-chart {
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 38.8rem;
    padding: 3.4rem 7.3rem;
    background-color: #fff;

    .pie {
      flex: 0.6;
    }

    .map {
      flex: 1.4;

      .map {
        margin-right: 7rem;
      }
    }
  }
}
</style>
